// extracted by mini-css-extract-plugin
export var SectionContainer = "index-module--SectionContainer--C79Oy";
export var SectionContainerTitle = "index-module--SectionContainerTitle--ibfKC";
export var SectionSubstanceBody = "index-module--SectionSubstanceBody--VeDaw";